import { getCookieValue } from '@lingoda/cookie';
import { isLocalHost } from '@lingoda/urls';
import type { KameleoonFeatureFlags, KameleoonFlagKey, KameleoonFlagValue } from './types';
import type { KameleoonVariationType } from '@kameleoon/react-sdk';

const variantValues: KameleoonFlagValue[] = ['on', 'variant'];
const disabledValue: KameleoonFlagValue = 'off';
export const allowedFlagValues: KameleoonFlagValue[] = ['on', 'variant', 'off', 'control'];
export const isFlagEnabled = (value: KameleoonFlagValue): boolean => value !== disabledValue;
export const isFlagVariant = (value: KameleoonFlagValue): boolean => variantValues.includes(value);

const OPTANON_CONSENT_COOKIE_NAME = 'OptanonConsent';
const COOKIEYES_CONSENT_COOKIE_NAME = 'cookieyes-consent';

export const shouldSetTrueKameleoonConsent = (): boolean => {
    if (shouldSkipConsentCheck()) {
        return true;
    }

    if (shouldUseCookieYes()) {
        return isCookieYesConsentGiven();
    }

    return isOptanonConsentGiven();
};

const shouldSkipConsentCheck = () => isLocalHost();

/**
 * temporary switch in case if we return back to OptanonConsent
 */
const shouldUseCookieYes = (): boolean => {
    return true;
};

const isOptanonConsentGiven = (): boolean => {
    const consentValue = getCookieValue(OPTANON_CONSENT_COOKIE_NAME);
    if (consentValue) {
        const groupsParam = consentValue.split('&').find((param) => param.startsWith('groups='));

        return !!groupsParam && groupsParam.includes('C0002:1');
    }

    return false;
};

const isCookieYesConsentGiven = (): boolean => {
    const consentValue = getCookieValue(COOKIEYES_CONSENT_COOKIE_NAME);
    if (consentValue) {
        const analyticsParams = consentValue
            .split(',')
            .find((param) => param.startsWith('analytics'));

        return !!analyticsParams && analyticsParams.includes('analytics:yes');
    }

    return false;
};

export const parseFeaturesFromKameleoon = (
    activeFlags: Map<KameleoonFlagKey, KameleoonVariationType>,
) => {
    const newFeatures: KameleoonFeatureFlags = {};

    for (const [featureName, value] of activeFlags) {
        const flagValue = value.key;

        if (isFlagValid(flagValue)) {
            newFeatures[featureName] = flagValue;
        }
    }

    return newFeatures;
};

export const isFlagValid = (flag: string): flag is KameleoonFlagValue => {
    return allowedFlagValues.includes(flag as KameleoonFlagValue);
};
